<template>
  <div>
    <div class="d-side-nav">
      <div class="d-side-nav__header">
        <div class="logo">
          <img class="img1" src="@/assets/media/logo-dr.png" />
          <img class="img2" src="@/assets/media/logo-text-en-dr.png" />
        </div>
        <div
          class="berger-menu"
          @click="$store.dispatch('theme/toggleSideNav')"
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div class="d-side-nav__nav">
        <ul>
          <li :class="{ active: $store.state.page.key === 'dashboard' }">
            <a href="#" @click.prevent="goto('/')">
              <div>
                <svg
                  style="width: 19px"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6667 2.33333V4.66667H14V2.33333H18.6667ZM7 2.33333V9.33333H2.33333V2.33333H7ZM18.6667 11.6667V18.6667H14V11.6667H18.6667ZM7 16.3333V18.6667H2.33333V16.3333H7ZM21 0H11.6667V7H21V0ZM9.33333 0H0V11.6667H9.33333V0ZM21 9.33333H11.6667V21H21V9.33333ZM9.33333 14H0V21H9.33333V14Z"
                  />
                </svg>
              </div>
              <span>داشبورد</span>
            </a>
          </li>

          <li
            class="sub-menu"
            :class="{ active: $store.state.page.key == 'reserves' }"
          >
            <a href="#">
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 14V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H13"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 2V6"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 2V6"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 10H21"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 20L18 22L22 18"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>مدیریت رزرو ها</span>
            </a>
            <ul>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'reserves' &&
                    $store.state.page.submenuKey == 'list',
                }"
              >
                <nuxt-link
                  to="/reserves/list"
                  @click="$store.state.page.key = 'reserves'"
                >
                  <span>لیست رزرو ها</span>
                </nuxt-link>
              </li>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'reserves' &&
                    $store.state.page.submenuKey == 'list',
                }"
              >
                <nuxt-link
                  to="/reserves/services"
                  @click="$store.state.page.key = 'reserves'"
                >
                  <span>سرویس ها</span>
                </nuxt-link>
              </li>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'reserves' &&
                    $store.state.page.submenuKey == 'holidays',
                }"
              >
                <nuxt-link
                  to="/reserves/holidays"
                  @click="$store.state.page.key = 'reserves'"
                >
                  <span>تعطیلات</span>
                </nuxt-link>
              </li>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'reserves' &&
                    $store.state.page.submenuKey == 'list',
                }"
              >
                <nuxt-link
                  to="/reserves/efficiency"
                  @click="$store.state.page.key = 'reserves'"
                >
                  <span>تایم کاری</span>
                </nuxt-link>
              </li>
            </ul>
          </li>

          <li
            :class="{ active: $store.state.page.key == 'factors' }"
            @click="$store.state.page.key = 'factors'"
          >
            <a href="#" @click.prevent="goto('/factors/list')">
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.0898 10.3701C19.0352 10.7225 19.8763 11.3076 20.5356 12.0713C21.1949 12.835 21.6509 13.7526 21.8616 14.7392C22.0723 15.7258 22.0307 16.7496 21.7409 17.716C21.451 18.6823 20.9222 19.5599 20.2033 20.2677C19.4844 20.9755 18.5986 21.4906 17.6278 21.7653C16.6571 22.0401 15.6327 22.0656 14.6495 21.8396C13.6663 21.6135 12.756 21.1432 12.0027 20.4721C11.2494 19.801 10.6775 18.9508 10.3398 18.0001"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 6H8V10"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.7098 13.8799L17.4098 14.5899L14.5898 17.4099"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>مدیریت پرداخت ها</span>
            </a>
          </li>

          <li
            class="sub-menu"
            :class="{ active: $store.state.page.key == 'articles' }"
          >
            <a href="#">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M 5 3 C 3.895 3 3 3.895 3 5 L 3 19 C 3 20.105 3.895 21 5 21 L 10 21 L 12 23 L 14 21 L 19 21 C 20.105 21 21 20.105 21 19 L 21 5 C 21 3.895 20.105 3 19 3 L 5 3 z M 7 7 L 9 7 L 9 9 L 7 9 L 7 7 z M 11 7 L 17 7 L 17 9 L 11 9 L 11 7 z M 7 11 L 9 11 L 9 13 L 7 13 L 7 11 z M 11 11 L 17 11 L 17 13 L 11 13 L 11 11 z M 7 15 L 9 15 L 9 17 L 7 17 L 7 15 z M 11 15 L 17 15 L 17 17 L 11 17 L 11 15 z"
                  ></path>
                </svg>
              </div>
              <span>مدیریت مقالات</span>
            </a>
            <ul>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'articles' &&
                    $store.state.page.submenuKey == 'article',
                }"
              >
                <nuxt-link to="/articles/article">
                  <span>لیست مقالات</span>
                </nuxt-link>
              </li>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'articles' &&
                    $store.state.page.submenuKey == 'category',
                }"
              >
                <nuxt-link to="/articles/category">
                  <span>دسته بندی ها</span>
                </nuxt-link>
              </li>
            </ul>
          </li>

          <li
            class="sub-menu"
            :class="{ active: $store.state.page.key == 'sliders' }"
          >
            <a href="#">
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 2C20.7348 2 20.4804 2.10536 20.2929 2.29289C20.1054 2.48043 20 2.73478 20 3V5H18V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2C16.7348 2 16.4804 2.10536 16.2929 2.29289C16.1054 2.48043 16 2.73478 16 3V4H8V3C8 2.73478 7.89464 2.48043 7.70711 2.29289C7.51957 2.10536 7.26522 2 7 2C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3V5H4V3C4 2.73478 3.89464 2.48043 3.70711 2.29289C3.51957 2.10536 3.26522 2 3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22C3.26522 22 3.51957 21.8946 3.70711 21.7071C3.89464 21.5196 4 21.2652 4 21V19H6V21C6 21.2652 6.10536 21.5196 6.29289 21.7071C6.48043 21.8946 6.73478 22 7 22C7.26522 22 7.51957 21.8946 7.70711 21.7071C7.89464 21.5196 8 21.2652 8 21V20H16V21C16 21.2652 16.1054 21.5196 16.2929 21.7071C16.4804 21.8946 16.7348 22 17 22C17.2652 22 17.5196 21.8946 17.7071 21.7071C17.8946 21.5196 18 21.2652 18 21V19H20V21C20 21.2652 20.1054 21.5196 20.2929 21.7071C20.4804 21.8946 20.7348 22 21 22C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM6 17H4V15H6V17ZM6 13H4V11H6V13ZM6 9H4V7H6V9ZM16 18H8V13H16V18ZM16 11H8V6H16V11ZM20 17H18V15H20V17ZM20 13H18V11H20V13ZM20 9H18V7H20V9Z"
                  />
                </svg>
              </div>
              <span>مدیریت اسلایدرها</span>
            </a>
            
            <ul>
              <li
                :class="{
                  active:
                    $store.state.page.key == 'sliders' &&
                    $store.state.page.submenuKey == 'list',
                }"
              >
                <nuxt-link to="/sliders/list">
                  <span>لیست اسلایدرها</span>
                </nuxt-link>
              </li>

              <li
                :class="{
                  active:
                    $store.state.page.key == 'sliders' &&
                    $store.state.page.submenuKey == 'category',
                }"
              >
                <nuxt-link to="/sliders/category">
                  <span>دسته بندی ها</span>
                </nuxt-link>
              </li>
            </ul>
          </li>

          <li
            :class="{ active: $store.state.page.key == 'settings' }"
            @click="$store.state.page.key = 'settings'"
          >
            <a href="#" @click.prevent="goto('/settings')">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">    
                  <path d="M 4 4 C 2.9 4 2 4.9 2 6 L 2 18 C 2 19.1 2.9 20 4 20 L 12.080078 20 C 12.033078 19.673 12 19.34 12 19 C 12 18.66 12.033078 18.327 12.080078 18 C 12.566078 14.609 15.475 12 19 12 C 19.34 12 19.673 12.027219 20 12.074219 L 20 12.078125 C 20.707 12.179125 21.378 12.385641 22 12.681641 L 22 8 C 22 6.9 21.1 6 20 6 L 12.828125 6 C 12.298125 6 11.789062 5.7890625 11.414062 5.4140625 L 10.585938 4.5859375 C 10.210938 4.2109375 9.701875 4 9.171875 4 L 4 4 z M 18.054688 14 C 17.925687 14 17.817734 14.096609 17.802734 14.224609 L 17.685547 15.236328 C 17.201547 15.404328 16.763766 15.660281 16.384766 15.988281 L 15.447266 15.582031 C 15.329266 15.531031 15.192906 15.578453 15.128906 15.689453 L 14.191406 17.310547 C 14.127406 17.421547 14.156766 17.563625 14.259766 17.640625 L 15.066406 18.240234 C 15.018406 18.487234 14.990234 18.74 14.990234 19 C 14.990234 19.26 15.018406 19.512766 15.066406 19.759766 L 14.259766 20.359375 C 14.156766 20.436375 14.126406 20.578453 14.191406 20.689453 L 15.128906 22.310547 C 15.192906 22.422547 15.329266 22.467016 15.447266 22.416016 L 16.384766 22.011719 C 16.763766 22.340719 17.201547 22.595672 17.685547 22.763672 L 17.802734 23.775391 C 17.817734 23.903391 17.925688 24 18.054688 24 L 19.925781 24 C 20.054781 24 20.162734 23.903391 20.177734 23.775391 L 20.294922 22.763672 C 20.778922 22.595672 21.216703 22.339719 21.595703 22.011719 L 22.53125 22.417969 C 22.64925 22.468969 22.787563 22.421547 22.851562 22.310547 L 23.787109 20.689453 C 23.851109 20.577453 23.823703 20.435375 23.720703 20.359375 L 22.912109 19.759766 C 22.960109 19.512766 22.990234 19.26 22.990234 19 C 22.990234 18.74 22.960109 18.487234 22.912109 18.240234 L 23.720703 17.640625 C 23.823703 17.563625 23.852109 17.421547 23.787109 17.310547 L 22.851562 15.689453 C 22.787562 15.578453 22.64925 15.531031 22.53125 15.582031 L 21.595703 15.988281 C 21.216703 15.660281 20.778922 15.404328 20.294922 15.236328 L 20.177734 14.224609 C 20.162734 14.096609 20.054781 14 19.925781 14 L 18.054688 14 z M 18.990234 17 C 20.094234 17 20.990234 17.895 20.990234 19 C 20.990234 20.104 20.094234 21 18.990234 21 C 17.886234 21 16.990234 20.104 16.990234 19 C 16.990234 17.895 17.886234 17 18.990234 17 z"></path>
                </svg>
              </div>
              <span>تنظیمات</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="d-side-nav-shadow"
      v-if="$store.state.theme.wideSideNav"
      @click="$store.dispatch('theme/toggleSideNav')"
    ></div>
  </div>
</template>

<script>
export default {
  name: "side-nav",
  mounted() {
    $(".sub-menu a").click(function (e) {
      e.preventDefault();
      var parent = $(this).parent();
      if (parent.hasClass("show-sub-menu")) parent.removeClass("show-sub-menu");
      else parent.addClass("show-sub-menu");
    });
  },
  methods: {
    goto(address) {
      if (this.$store.getters.isMobile)
        this.$store.dispatch("theme/toggleSideNav");
      this.$router.push(address);
    },
  },
};
</script>

<style scoped></style>
